import React, { ReactNode, useState } from 'react';

import { ExtendedSearchResults, SearchContext } from './search.context';

interface ISearchProviderProps {
  children: ReactNode;
  searchFilter?: string;
}

export const jabraProductSearchFilter =
  "not (pageUrl eq null and supportPageUrl eq null) and attributes/any(a: a eq 'Product_Portfolio|Jabra') and (attributes/all(a: a ne 'Meta_Refurbished|True') or attributes/any(a: a eq 'Meta_Accessorytype|17'))";

export const SearchProvider: React.FC<ISearchProviderProps> = ({
  children,
  searchFilter,
}: ISearchProviderProps) => {
  const [searchResults, setSearchResults] = useState<ExtendedSearchResults>({
    count: 0,
    items: [],
  });

  return (
    <SearchContext.Provider
      value={{
        searchResults,
        setSearchResults,
        searchFilter: searchFilter || jabraProductSearchFilter,
      }}
    >
      {children}
    </SearchContext.Provider>
  );
};

export default SearchProvider;
